import React from 'react';
import AddElement from './AddElement';

interface AddPhoneProps {
  onClick: () => void;
}

const AddPhone: React.FC<AddPhoneProps> = ({ onClick }) => (
  <AddElement label="Phone" onClick={onClick} />
);

export default AddPhone;
